import React from 'react'

const BotIcon = props => {
  return (
    <svg width="32" height="34" viewBox="0 0 32 34" xmlns="http://www.w3.org/2000/svg">
      <g stroke="#000" fill="none" fill-rule="evenodd">
        <path
          d="M24.321 10.007H7.531a3.956 3.956 0 0 0-3.961 3.951v11.213a3.956 3.956 0 0 0 3.962 3.952h3.023v4.112c0 .026.03.04.05.026l6.19-4.093 1.552-.029h4.356l1.618-.016a3.957 3.957 0 0 0 3.962-3.952V13.958a3.957 3.957 0 0 0-3.962-3.951zM15.835 25.83c-2.514 0-4.59-1.757-4.907-4.032h9.815c-.318 2.275-2.394 4.032-4.908 4.032z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M1.2 21.307v-4.406a1.28 1.28 0 0 1 1.28-1.278h.967v6.962H2.48A1.28 1.28 0 0 1 1.2 21.307zM30.653 21.307v-4.406a1.28 1.28 0 0 0-1.28-1.278h-.967v6.962h.966a1.28 1.28 0 0 0 1.281-1.278z" />
        <path
          d="M18.743 3.665a2.37 2.37 0 0 1-1.687 2.265v3.773h-1.37V5.93A2.37 2.37 0 0 1 14 3.665a2.371 2.371 0 0 1 4.743 0z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g strokeLinecap="round" strokeLinejoin="round">
          <path d="m19 15 2 2M19 17l2-2" />
        </g>
        <g strokeLinecap="round" strokeLinejoin="round">
          <path d="m11 15 2 2M11 17l2-2" />
        </g>
      </g>
    </svg>
  )
}

export default BotIcon
